import { BlockType } from './terrain'

export enum ItemType {
  rawBeef = 100,
  cookedBeef = 101,
  stick = 102,
  woodenPickaxe = 103,
  leather = 104,
  rawPorkchop = 105,
  cookedPorkchop = 106,
  rawMutton = 107,
  cookedMutton = 108,
  rawChicken = 109,
  cookedChicken = 110,
  feather = 111,
  egg = 112,
  rawRabbit = 113,
  cookedRabbit = 114,
  rabbitHide = 115,
  rabbitFoot = 116,
  wool = 117,
  rottenFlesh = 118,
  bone = 119,
  string = 120,
  spiderEye = 121,
  gunpowder = 122,
  stonePickaxe = 123,
  bucket = 124,
  waterBucket = 125,
  lavaBucket = 126
}

export type InventoryItemType = BlockType | ItemType

const PLACEABLE_BLOCKS = new Set<number>(Object.values(BlockType).filter(
  value => typeof value === 'number'
) as number[])

export const isBlockType = (type: InventoryItemType): type is BlockType => {
  return PLACEABLE_BLOCKS.has(type as number)
}

export const isFoodItem = (type: InventoryItemType) => {
  return (
    type === ItemType.rawBeef ||
    type === ItemType.cookedBeef ||
    type === ItemType.rawPorkchop ||
    type === ItemType.cookedPorkchop ||
    type === ItemType.rawMutton ||
    type === ItemType.cookedMutton ||
    type === ItemType.rawChicken ||
    type === ItemType.cookedChicken ||
    type === ItemType.rawRabbit ||
    type === ItemType.cookedRabbit ||
    type === ItemType.rottenFlesh
  )
}

export const getFoodValue = (type: InventoryItemType) => {
  switch (type) {
    case ItemType.cookedBeef:
      return 8
    case ItemType.rawBeef:
      return 3
    case ItemType.cookedPorkchop:
    case ItemType.cookedMutton:
      return 8
    case ItemType.rawPorkchop:
    case ItemType.rawMutton:
      return 3
    case ItemType.cookedChicken:
    case ItemType.cookedRabbit:
      return 6
    case ItemType.rawChicken:
    case ItemType.rawRabbit:
      return 2
    case ItemType.rottenFlesh:
      return 1
    default:
      return 0
  }
}

export const getMaxDurability = (type: InventoryItemType): number => {
  switch (type) {
    case ItemType.woodenPickaxe:
      return 60
    case ItemType.stonePickaxe:
      return 132
    default:
      return 0
  }
}

export const isPickaxe = (type: InventoryItemType | null): boolean => {
  return type === ItemType.woodenPickaxe || type === ItemType.stonePickaxe
}

export const isBucket = (type: InventoryItemType | null): boolean => {
  return (
    type === ItemType.bucket ||
    type === ItemType.waterBucket ||
    type === ItemType.lavaBucket
  )
}

export const isTool = (type: InventoryItemType): boolean => {
  return getMaxDurability(type) > 0
}
